// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infot {
  font-size: 1.2rem;
  text-align: left;
  color: #6564DB;
  font-weight: bold;
}

.infoh {
  text-align: left;
}

.footer {
  padding-bottom: 0;
  margin-bottom: 0;
}

.imk {
  max-width: 800px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Help/Help.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAIA;EACI,iBAAA;EACA,gBAAA;EACA,cCHQ;EDIR,iBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;AAHJ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n\n.infot{\n    font-size: 1.2rem;\n    text-align: left;\n    color: $palette-2;\n    font-weight:bold;\n}\n\n.infoh{\n    text-align: left;\n}\n\n.footer{\n    padding-bottom: 0;\n    margin-bottom: 0;\n}\n\n.imk{\n    max-width: 800px;\n    align-items: center;\n}","\n$black: #011627;\n$white: #FFFFFF;\n$palette-1:#2a9679;\n$palette-2: #6564DB;\n$palette-3: #FAF9F6;\n\n$palette-1-dark: darken($palette-1, 5%);\n$palette-1-light: lighten($palette-1, 10%);\n$palette-2-dark: darken($palette-2, 10%);\n$palette-2-light: lighten($palette-2, 10%);\n$palette-3-dark: darken($palette-3, 5%);\n$palette-3-darker: darken($palette-3, 10%);\n$palette-3-light: lighten($palette-3, 10%);\n\n$text-host: #F06543;\n$text-host-light: lighten($text-host, 15%);\n$text-pathogen: #A68F26;\n$text-pathogen-light: lighten($text-pathogen, 20%);\n\n$nav-outline: #ffffff;\n$nav-outline-hvr: #ffffff;\n\n$text-ghost: #b4b4b4;\n$text-light:#ffffff;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n// $nav-back:#4fa2a2;\n$nav-back:#288DC2;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
